import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AccountEffects } from './store';
import { reducers, metaReducers } from './reducers';
import { BrandsEffects } from './store/brands/brands.effects';
import { RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { DistributorsEffects } from 'src/app/core/store/distributors/distributors.effects';
import { ConsumersEffects } from 'src/app/core/store/consumers/consumers.effects';
import { PlansEffects } from 'src/app/core/store/plans/plans.effects';
import { CountriesEffects } from 'src/app/core/store/countries/countries.effects';
import { ConfigsEffects } from 'src/app/core/store/configs/configs.effects';
import { LanguagesEffects } from 'src/app/core/store/languages/languages.effects';

@NgModule({
  imports: [
    CommonModule,
    NzNotificationModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    EffectsModule.forRoot([
      AccountEffects,
      BrandsEffects,
      DistributorsEffects,
      ConsumersEffects,
      PlansEffects,
      CountriesEffects,
      ConfigsEffects,
      LanguagesEffects,
    ]),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
      routerState: RouterState.Minimal,
    }),
  ],
  providers: [DatePipe],
})
export class CoreModule {}
